import { useEffect, useRef } from 'react';
import { useLocation } from '@trello/router';

export const useLocationHandler = (onLocationChange: () => void) => {
  const prevUrlRef = useRef<{
    origin: string;
    pathname: string;
  }>();
  const { origin, pathname } = useLocation();

  useEffect(() => {
    const prevUrl = prevUrlRef.current;
    const url = {
      origin,
      pathname,
    };

    prevUrlRef.current = url;
    const urlChanged =
      prevUrl !== undefined &&
      `${prevUrl.origin}${prevUrl.pathname}` !== `${url.origin}${url.pathname}`;

    if (urlChanged) {
      onLocationChange();
    }
  }, [origin, pathname, onLocationChange]);
};
